import jwtDecode from 'jwt-decode';

let _token;

function getToken() {
  if (_token) {
    return _token;
  }

  return _token = getURLParam('token');
}

export function getTokenData() {
  const token = getToken();

  console.log(jwtDecode(token));
  if (!token) {
    return {};
  }

  return jwtDecode(token);
}


export function getURLParam(param) {
  const params = new URLSearchParams(window.location.search);

  return  params.get(param);
}

export function getLanguageFromLocale(locale) {
  if(!locale || locale.lenght < 2) {
    return 'EN';
  }
  return  locale.substr(0,2).toUpperCase();
}